var _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallideLockupHorizontalLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 100",
    width: 400,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Callide \u2014 horizontal lockup") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0) scale(0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 121.631 33.426 A 70 70 0 1 0 121.631 166.574 L 119.000 132.909 A 38 38 0 1 1 119.000 67.091 Z",
    fill: "#f4f1ea"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 64,
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    fontSize: 44,
    fontWeight: 600,
    letterSpacing: 6,
    fill: "#f4f1ea"
  }, "CALLIDE")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallideLockupHorizontalLight);
export default __webpack_public_path__ + "static/media/callide-lockup-horizontal-light.8798f9100cf5d6a1cd16310e0ca986d5.svg";
export { ForwardRef as ReactComponent };